<template>
    <el-form :model="user" ref="registerForm" :rules="rules" label-position="left">
        <!-- <h3 class="login_title">ユーザ登録</h3> -->
        <el-form-item prop="name">
            <el-input type="text" v-model="user.name" auto-complete="off" :placeholder="$t('register.name')"></el-input>
        </el-form-item>
        <el-form-item prop="mailaddress">
            <el-input  v-model="user.mailaddress" auto-complete="off" :placeholder="$t('register.mail')"></el-input>
        </el-form-item>
        <el-form-item prop="mailaddress2">
            <el-input v-model="user.mailaddress2" auto-complete="off" :placeholder="$t('register.mail2')"></el-input>
        </el-form-item>
        <el-form-item prop="company">
            <el-input v-model="user.company" auto-complete="off" :placeholder="$t('register.company')"></el-input>
        </el-form-item>
        <el-form-item prop="position">
            <el-input v-model="user.position" auto-complete="off" :placeholder="$t('register.position')"></el-input>
        </el-form-item>
        <el-form-item prop="occupation">
            <el-input v-model="user.occupation" auto-complete="off" :placeholder="$t('register.occupation')"></el-input>
        </el-form-item>
        <el-form-item prop="telno">
            <el-input v-model="user.telno" auto-complete="off" :placeholder="$t('register.tel')"></el-input>
        </el-form-item>
        <el-form-item prop="purchasedate">
            <el-date-picker
              v-model="user.purchasedate"
              type="date"
              :placeholder="$t('register.purchaseDate')">
            </el-date-picker>
        </el-form-item>
        <el-form-item prop="serid">
            <el-input v-model="user.serid" auto-complete="off" :placeholder="$t('register.licenseNo')"></el-input>
        </el-form-item>
        <el-form-item prop="voice">
            <el-input type="text" v-model="user.voice" auto-complete="off" :placeholder="$t('register.voice')"></el-input>
        </el-form-item>
        <el-form-item prop="channel">
            <el-input type="text" v-model="user.channel" auto-complete="off" :placeholder="$t('register.channel')"></el-input>
        </el-form-item>
        <el-form-item prop="kaptcha">
            <el-input type="text" v-model="user.kaptcha" auto-complete="off" :placeholder="$t('register.captcha')"></el-input>
        </el-form-item>
        <el-form-item style="width: 100%">
          <!-- add padding-top for IE -->
            <el-image :src="kaptcha" @click="refreshCode" :alt="$t('register.captchaAlt')" style="padding-top: 15px" >
                <div slot="placeholder" class="image-slot">
                    <i class="el-icon-loading"></i>
                </div>
            </el-image>
            <el-link type="primary" @click="refreshCode">{{ $t('register.refreshCode') }}</el-link><br>
            <el-button type="primary" @click="submitForm('registerForm')">{{ $t('register.submit') }}</el-button>
            <el-button type="primary" @click="reset('registerForm')">{{ $t('register.reset') }}</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
  data: function () {
    return {
      kaptcha: this.$globalConst.APIServiceURL + (this.$globalConst.port ? ':' + this.$globalConst.port : '') + '/kaptcha.jpg?t=' + new Date().getTime(),
      user: {
        name: '',
        mailaddress: '',
        mailaddress2: '',
        company: '',
        position: '',
        occupation: '',
        telno: '',
        purchasedate: '',
        serid: '',
        voice: '',
        channel: '',
        kaptcha: ''
      }
    }
  },
  computed: {
    rules () {
      const checkEmail = (rule, value, cb) => {
        const regEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
        if (regEmail.test(value)) {
          return cb()
        }
        cb(new Error(this.$t('register.errEmail')))
      }
      const checkEmail2 = (rule, value, cb) => {
        if (this.user.mailaddress === value) {
          return cb()
        }
        cb(new Error(this.$t('register.errEmailMatch')))
      }
      return {
        name: [
          { required: true, message: this.$t('register.errName'), trigger: 'blur' }
        ],
        mailaddress: [
          { required: true, message: this.$t('register.errMailRequired'), trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ],
        mailaddress2: [
          { required: true, message: this.$t('register.errMailRequired'), trigger: 'blur' },
          { validator: checkEmail2, trigger: 'blur' }
        ],
        purchasedate: [
          { required: true, message: this.$t('register.errDateRequired'), trigger: 'blur' }
        ],
        serid: [
          { required: true, message: this.$t('register.errLicRequired'), trigger: 'blur' },
          { min: 6, message: this.$t('register.errLicInvalid'), trigger: 'blur' }
        ],
        kaptcha: [
          { required: true, message: this.$t('register.errCaptcha'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async refreshCode () {
      this.kaptcha = this.$globalConst.APIServiceURL + (this.$globalConst.port ? ':' + this.$globalConst.port : '') + '/kaptcha.jpg?t=' + new Date().getTime()
    },

    submitForm (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const webSite = this.$globalConst.APIServiceURL + (this.$globalConst.port ? ':' + this.$globalConst.port : '') + '/register'
          const { data: res } = await this.$http.post(webSite, this.user, { withCredentials: true })
          if (res.code === 'noErr') {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
          this.refreshCode()
        } else {
          this.$message.error(this.$t('register.errInvalid'))
        }
      })
    },

    reset (formName) {
      this.$refs[formName].resetFields()
      this.refreshCode()
    }

  }

}
</script>

<style scoped>
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 810px
}
</style>
